// extracted by mini-css-extract-plugin
module.exports = {"markdown-content":"styles-module__markdown-content___3q_kD"};